export enum FlagSortOrder {
  ARCHIVED_ASC = 'archivedDate',
  ARCHIVED_DESC = '-archivedDate',
  NAME = 'name',
  NAME_REVERSE = '-name',
  NEWEST_FIRST = '-creationDate',
  OLDEST_FIRST = 'creationDate',
  TARGETING_MODIFIED_OLDEST_FIRST = 'targetingModifiedDate',
  TARGETING_MODIFIED_NEWEST_FIRST = '-targetingModifiedDate',
}

/**
 * These are considered search options or filters, but not FilterKinds.
 */
export enum AdditionalFilterOption {
  QUERY = 'q',
  SORT = 'sort',
  ENVIRONMENT = 'filterEnv',
}
